import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    downtimeSavedContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
        gap: 50,
        padding: `0 ${theme.spacing(8)} `,
    },
    title: {
        fontWeight: "700 !important",
    },
    subtitle: {
        color: theme.palette.error.main,
    },
    summaryBox: {
        background: theme.palette.primary.light,
        padding: `${theme.spacing(6)} ${theme.spacing(9)}`,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 20,
    },
    summarySection: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
    },
    summaryTitle: {
        color: theme.palette.primary.dark,
    },
    summaryNotes: {
        color: theme.palette.primary.darker,
    },
}));
